import React from "react";
import { Pleb } from "../../../models/Pleb";
import { ChatAvatar } from "./ChatAvatar";
import TileList from "./TileList";
import { ConnectionButton } from "./ConnectionButton";
import { useConfirm } from "../../../hooks/useConfirm";
import { useRouter } from "../../../hooks/useRouter";
import UserBadge from "./UserBadge";
import { ButtonSendTo } from "../../../components/ButtonSendTo";

interface SearchTilePlebProps {
  pleb: Pleb;
  index: number;
  onTap: () => void;
  distance: string | null;
}

const SearchTilePleb: React.FC<SearchTilePlebProps> = ({ pleb, index, onTap, distance }) => {
    const {navigateFromFullChannelId} = useRouter();
    const {openConnectDialog} = useConfirm();

    return (
        <TileList 
            onTap={onTap}
            isSelected={false}
        >
        <div className="flex items-stretch">
            <div className="mr-2">
            <ChatAvatar 
                user={pleb} 
                loading={index < 15 ? 'eager' : 'lazy'}
            />
            </div>
            
            <div className="flex-1 truncate mr-2">
            <div className="flex flex-col truncate">
                <div className="flex items-center gap-1 leading-4">
                <p className="font-semibold truncate">
                    {pleb.name || ''}
                </p>
                {pleb?.badge && <UserBadge badge={pleb.badge} />}
                </div>
                <p
                className={`truncate font-normal text-sm text-brand-grey`}
                >
                    @{pleb.slug}
                </p>
                <p
                className={`truncate font-normal text-sm`}
                >
                {distance}
                </p>
            </div>
            </div>

            <div className="flex flex-row items-center gap-2">
            <ButtonSendTo 
                pleb={pleb}
                width={30}
            />
            {
                pleb.connection &&
                <ConnectionButton 
                    connection={pleb.connection}
                    onConnect={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    if(pleb)
                        openConnectDialog(pleb.toJson());
                    }}
                    onChat={(connectionId) => {
                    navigateFromFullChannelId(connectionId);
                    }}
                />
            }
            </div>
        </div>
        </TileList>
    );
};

export default SearchTilePleb;